export const PDF_BADGE_PROPERTIES = {
  label: '📄 PDF',
  tooltipText:
    'In the coming months we will be updating these activities to our new digital format!',
};

export const ACTIVITIES_BADGE_PROPERTIES = {
  label: '✨ Digital Slides',
  tooltipText:
    'No more jumping between tabs! These activities are now fully digital, keeping everything in one place. Stimulus are integrated for a seamless, engaging experience.',
};

export const BADGE_TEXT_PDF_FORMAT = 'PDF format';
export const BADGE_TEXT_DIGITAL_FORMAT = 'digital format';
